import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function HeroSection() {
  return <section className="relative w-full h-screen min-h-[640px] max-h-[1080px] bg-black overflow-hidden flex flex-col justify-between">
      {/* Full-Bleed Hero Image */}
      <div className="absolute inset-0 w-full h-full">
        <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/hero_architectural_residence.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/hero_architectural_residence.png-wvc-sizes" alt="Bespoke luxury architectural residence interior with panoramic views" className="w-full h-full object-cover object-center select-none" loading="eager" decoding="async" src="https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/IMG_6448-scaled.jpg" />
        {/* Subtle vignette/contrast overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20 pointer-events-none" />
      </div>

      {/* Hidden Accessible H1 for Semantic SEO Structure */}
      <h1 className="sr-only">
        S & L Design — Luxury Interior Design
      </h1>

      {/* Top Spacer */}
      <div className="relative z-10 w-full" />

      {/* Bottom Controls & Captions Bar */}
      <div className="relative z-10 w-full px-6 md:px-12 lg:px-16 pb-8 md:pb-10 flex items-end justify-between">
        {/* Bottom Left Project / Location Caption */}
        <div className="flex flex-col">
          <span className="text-[10px] md:text-xs tracking-[0.3em] uppercase text-white/90 font-light font-sans">HOUSE OF CONTRAST&nbsp;</span>
        </div>

        {/* Bottom Center Scroll Down Indicator */}
        <div className="absolute left-1/2 -translate-x-1/2 bottom-8 md:bottom-10">
          <Link to="#explore" aria-label="Scroll to featured content" className="flex flex-col items-center justify-center text-white/80 hover:text-white transition-all duration-300 group">
            <ChevronDown className="w-5 h-5 md:w-6 md:h-6 stroke-[1.25] transition-transform duration-300 group-hover:translate-y-1" />
          </Link>
        </div>

        {/* Bottom Right Spacer for balanced flex layout */}
        <div className="hidden md:block w-32" />
      </div>
    </section>;
}